import { Button } from "@/components/ui/button";
import QRCode from "qrcode";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
const Contato = () => {
  const {
    hash
  } = useLocation();
  const donation = useMemo(() => ({
    pixKey: "86043696517",
    recipient: "Edenailton Batista",
    bank: "Bradesco"
  }), []);
  const [copiedField, setCopiedField] = useState<null | "pix" | "recipient" | "bank">(null);
  const [pixQrCodeUrl, setPixQrCodeUrl] = useState<string | null>(null);
  const handleCopy = useCallback(async (value: string, field: "pix" | "recipient" | "bank") => {
    await navigator.clipboard.writeText(value);
    setCopiedField(field);
  }, []);
  useEffect(() => {
    if (!copiedField) return;
    const timeout = window.setTimeout(() => setCopiedField(null), 1800);
    return () => window.clearTimeout(timeout);
  }, [copiedField]);
  useEffect(() => {
    let cancelled = false;

    // Observação: QR Code gerado a partir da chave PIX (não é payload EMV).
    QRCode.toDataURL(donation.pixKey, {
      width: 320,
      margin: 1,
      errorCorrectionLevel: "M"
    }).then(url => {
      if (cancelled) return;
      setPixQrCodeUrl(url);
    }).catch(() => {
      if (cancelled) return;
      setPixQrCodeUrl(null);
    });
    return () => {
      cancelled = true;
    };
  }, [donation.pixKey]);
  useEffect(() => {
    if (hash !== "#apoie") return;
    const target = document.getElementById("apoie");
    if (!target) return;

    // aguarda o layout estabilizar (header sticky, imagens, etc.)
    window.setTimeout(() => {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 50);
  }, [hash]);
  return <section className="section-shell">
      <header className="mb-10 max-w-3xl space-y-3">
        <p className="section-title">Contato</p>
        <h1 className="section-heading">Quer caminhar conosco?</h1>
        <p className="section-subtitle">
          Envie uma mensagem para conhecer melhor o Instituto, agendar uma visita, convidar a equipe para sua igreja ou
          tirar dúvidas sobre o curso de Teologia e os projetos sociais.
        </p>
      </header>

      <div className="grid gap-10 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-start">
        <form className="card-ambient space-y-4 p-6">
          <div className="grid gap-4 md:grid-cols-2">
            <div className="space-y-1 text-sm">
              <label htmlFor="name" className="font-medium">
                Nome completo
              </label>
              <input id="name" className="h-10 w-full rounded-md border border-input bg-background px-3 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring" placeholder="Digite seu nome" />
            </div>
            <div className="space-y-1 text-sm">
              <label htmlFor="email" className="font-medium">
                E-mail
              </label>
              <input id="email" type="email" className="h-10 w-full rounded-md border border-input bg-background px-3 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring" placeholder="seuemail@exemplo.com" />
            </div>
          </div>

          <div className="space-y-1 text-sm">
            <label htmlFor="assunto" className="font-medium">
              Assunto
            </label>
            <input id="assunto" className="h-10 w-full rounded-md border border-input bg-background px-3 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring" placeholder="Convite, dúvida, parceria..." />
          </div>

          <div className="space-y-1 text-sm">
            <label htmlFor="mensagem" className="font-medium">
              Mensagem
            </label>
            <textarea id="mensagem" rows={5} className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring" placeholder="Conte como podemos servir você ou sua igreja." />
          </div>

          <p className="text-xs text-muted-foreground">
            Este formulário é ilustrativo e ainda não envia dados para nenhum sistema. Em breve você poderá acompanhar o
            andamento do seu contato diretamente pelo site.
          </p>

          <Button type="submit" className="btn-pill-lg">
            Enviar mensagem
          </Button>
        </form>

        <aside className="space-y-6 text-sm text-muted-foreground">
          <div id="apoie" className="card-ambient hover-scale animate-fade-in scroll-mt-24 space-y-4 p-6">
            <div className="space-y-2">
              <p className="text-xs font-medium uppercase tracking-wide text-primary">Missão & Sustentabilidade</p>
              <h2 className="text-lg font-semibold text-foreground">Apoie a Missão do IESSA</h2>
              <p className="leading-relaxed">
                Seu apoio fortalece a formação bíblica, amplia ações sociais e sustenta frentes missionárias que alcançam
                famílias com cuidado, ensino e esperança.
              </p>
            </div>

            <div className="grid gap-3">
              <div className="rounded-lg border border-input bg-background/50 p-3">
                <div className="flex items-start justify-between gap-3">
                  <div className="space-y-1">
                    <p className="font-medium text-foreground">Doações (PIX / Banco)</p>
                    <p className="text-xs">
                      Se desejar contribuir com a missão, utilize os dados abaixo. Para sua segurança, confirme sempre o
                      favorecido antes de concluir.
                    </p>
                  </div>
                </div>

                <div className="mt-3 grid gap-2 text-xs">
                  <div className="grid grid-cols-[1fr_auto] items-center gap-3 rounded-md border border-input bg-background/60 p-2">
                    <div className="min-w-0">
                      <p className="text-muted-foreground">PIX (chave)</p>
                      <p className="truncate font-medium text-foreground">{donation.pixKey}</p>
                    </div>
                    <Button type="button" variant="outline" size="sm" onClick={() => handleCopy(donation.pixKey, "pix")}>
                      {copiedField === "pix" ? "Copiado" : "Copiar"}
                    </Button>
                  </div>

                  <div className="grid gap-2 rounded-md border border-input bg-background/60 p-2">
                    <p className="text-muted-foreground">QR Code (PIX)</p>
                    <div className="flex items-center justify-center rounded-md border border-input bg-background p-3">
                      {pixQrCodeUrl ? <img src={pixQrCodeUrl} alt="QR Code da chave PIX para doação ao IESSA" loading="lazy" width={192} height={192} className="h-48 w-48" /> : <div className="h-48 w-48 animate-pulse rounded-md bg-muted" />}
                    </div>
                    <p className="text-xs text-muted-foreground">
                      Dica: ao escanear, confira o favorecido antes de confirmar.
                    </p>
                  </div>

                  <div className="rounded-md border border-input bg-background/60 p-2">
                    <p className="text-muted-foreground">Favorecido</p>
                    <p className="font-medium text-foreground">{donation.recipient}</p>
                  </div>

                  <div className="rounded-md border border-input bg-background/60 p-2">
                    <p className="text-muted-foreground">Banco</p>
                    <p className="font-medium text-foreground">{donation.bank}</p>
                  </div>

                  <div className="rounded-md border border-input bg-background/60 p-2">
                    <p className="font-medium text-foreground">Avisos de segurança</p>
                    <ul className="mt-1 list-disc space-y-1 pl-4 text-muted-foreground">
                      <li>Confira o nome do favorecido antes de confirmar o pagamento.</li>
                      <li>Não compartilhe comprovantes com dados sensíveis em canais públicos.</li>
                      <li>Em caso de dúvida, confirme pelos canais oficiais da página.</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="rounded-lg border border-input bg-background/50 p-3">
                <p className="font-medium text-foreground">Parcerias institucionais</p>
                <p className="text-xs">Igrejas e organizações apoiando projetos e capacitações.</p>
              </div>
              <div className="rounded-lg border border-input bg-background/50 p-3">
                <p className="font-medium text-foreground">Voluntariado</p>
                <p className="text-xs">Serviço em eventos, ações locais e apoio técnico conforme necessidade.</p>
              </div>
            </div>

            <Button type="button" className="btn-pill-lg w-full" onClick={() => {
            document.getElementById("name")?.focus();
          }}>
              Entre em contato para apoiar
            </Button>
          </div>

          <div>
            <h2 className="mb-2 text-base font-semibold text-foreground">Informações institucionais</h2>
            <p>
              Telefone / WhatsApp:{" "}
              <a href="https://wa.me/5574981070229" target="_blank" rel="noreferrer" className="text-primary hover:underline">
                (74) 9 8107-0229
              </a>
            </p>
            <p>
              E-mail:{" "}
              <a href="mailto:iessa.institutoevangelistico@gmail.com" className="text-primary hover:underline">
                iessa.institutoevangelistico@gmail.com
              </a>
            </p>
            <p>Endereço: Rua Bento Pereira, S/N, Vila Cardoso. Caldeirão Grande - BA</p>
          </div>

          <div>
            <h2 className="mb-2 text-base font-semibold text-foreground">Mensagem de acolhimento</h2>
            <p>
              Recebemos cada contato com carinho e oração. Mesmo que sua dúvida pareça simples, tenha liberdade para
              escrever. Nossa equipe terá alegria em responder e caminhar com você.
            </p>
          </div>
        </aside>
      </div>
    </section>;
};
export default Contato;